import React, { Component } from 'react';
import styled, { keyframes } from 'styled-components';
import withConfig from '../../../context/withConfig';

import Image from '../BotMessage/Image';

const UserMessageContainer = styled.div`
  display: flex;
  justify-content: end;
`;

const MessageContainer = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: end;
  flex-shrink: 0;
  max-width: 98vw;
  width: ${props => props.imageWidth};
  align-items: flex-end;
  word-wrap: break-word;
  margin-top: 10px;
  margin-bottom: 10px;
`;

const Grow = styled.div`
  flex-grow: 1;
  min-width: 20px;
`;

const messageAppear = keyframes`
  from {
    opacity: 0;
    transform: translateY(10px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
`;

const UserMessageWrapper = styled.div`
  background-color: ${props => props.theme.userMessageBubbleColor};
  color: ${props => props.theme.userMessageFontColor};
  max-width: 70vw;
  padding: 16px 18px;
  flex-grow: 0;
  word-break: break-word;
  word-wrap: break-word;
  border-radius: 20px;
  margin-right: 20px;
  cursor: ${props => (props.cursor ? props.cursor : 'auto')};
  text-decoration: ${props =>
    props.type && props.type.toLowerCase().includes('pdf') ? 'underline' : 'none'};

  animation-name: ${messageAppear};
  animation-duration: 300ms;
  animation-timing-function: linear;
  animation-fill-mode: backwards;
`;

const TextTips = styled.div`
  margin-top: 5px;
  text-align: center;
`;

class UserMessage extends Component {
  handleOnClick = () => {
    const { attachmentUrl, objectUrl } = this.props.activity;
    if (attachmentUrl) {
      return window.open(attachmentUrl, '_blank', 'noopener,noreferrer');
    }
    return window.open(objectUrl, '_blank', 'noopener,noreferrer');
  };

  getImageUrl = ({ attachmentUrl, source, objectUrl }) => {
    if (attachmentUrl) {
      return attachmentUrl;
    } else if (source === 'user' && objectUrl) {
      return objectUrl;
    }
    return '';
  };

  getUserMessageWrapper = () => {
    const {
      activity,
      config: { enableClickToOpen }
    } = this.props;
    const { messageType, displayField, text } = activity;
    const displayText = displayField ? activity[displayField] : text;
    const imageUrl = this.getImageUrl(activity);
    // messageType indicates that user has sent an image or a pdf file
    if (messageType) {
      return (
        <UserMessageWrapper
          data-test-type="userMessage"
          onClick={this.handleOnClick}
          cursor="pointer"
          type={messageType || ''}
        >
          {messageType.toLowerCase().includes('image') && (
            <React.Fragment>
              <Image src={imageUrl} />
              {enableClickToOpen && <TextTips>Click to open in a new tab</TextTips>}
            </React.Fragment>
          )}
          {messageType.toLowerCase().includes('pdf') && displayText}
        </UserMessageWrapper>
      );
    }
    return <UserMessageWrapper data-test-type="userMessage">{displayText}</UserMessageWrapper>;
  };
  render() {
    const {
      config: { imageWidth },
      activity: { attachmentUrl, messageType }
    } = this.props;
    const width =
      imageWidth && attachmentUrl && messageType.includes('image') ? imageWidth : '100%';
    return (
      <UserMessageContainer>
        <MessageContainer imageWidth={width}>
          <Grow /> {this.getUserMessageWrapper()}
        </MessageContainer>
      </UserMessageContainer>
    );
  }
}

export default withConfig(UserMessage);



// WEBPACK FOOTER //
// ./src/components/MessageHistory/UserMessage/index.js